import Swal from "sweetalert2";
import { oneOf, notIn } from "../helpers";
import { STRINGS } from "../declarations";

export class Notice {
	constructor(notice) {
		if (!notice?.message || notice?.message?.length == 0) return "";

		const label = oneOf(notice.label?.toUpperCase(), "INFO");
		const autohide = notIn(notice, "autohide", true);
		const timeout = oneOf(notice.timeout, 2000);
		const message = oneOf(notice.message);

		const type = label.toLowerCase();

		const config = {
			toast: true,
			position: "top-end",
			icon: type,
			title: message,
			showConfirmButton: false,
			showCloseButton: true,
		};

		if (autohide) {
			config.timer = timeout;
			config.timerProgressBar = true;
		}

		Swal.fire(config);
	}
}

/**
 * Notice Class
 * {message, label, autohide, timeout, position}
 */
export class NoticeWrapper {
	message;
	label;
	autohide;
	timeout;
	position;

	constructor(
		message = "",
		label = STRINGS.INFO,
		autohide = true,
		timeout = 2000,
		position = "top-end",
	) {
		this.message = message;
		this.label = label;
		this.autohide = autohide;
		this.timeout = timeout;
		this.position = position;

		new Notice(this);
	}
}
